import React from "react";
import { Grid, Row, Col, Nav } from "react-bootstrap";
import { Switch, Route, Redirect } from "react-router";
import PropTypes from "prop-types";

import VerbundsteuerungContainer from "./VerbundsteuerungContainer";
import VerbundInfoPanelContainer from "./VerbundInfoPanelContainer";
import KompressorsteuerungContainer from "./KompressorsteuerungContainer";
import KompressorInfoPanelContainer from "./KompressorInfoPanelContainer";
import ZubehoerContainer from "./ZubehoerContainer";
import ZubehoerInfoPanelContainer from "./ZubehoerInfoPanelContainer";

import AlmigLink from "../grundelemente/AlmigLink";
import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";

const Uebersicht = (props) => (
	<Grid>
		<Row>
			<Col xs={12}>
				<BreadcrumbContainer />
			</Col>
		</Row>
		<Row>
			<Col sm={12} md={3}>
				<Nav stacked className="Navispalte">
					<AlmigLink to="/overview/master" />
					<AlmigLink to="/overview/compressor" />
					<AlmigLink to="/overview/accessories" disabled={!props.hasAnyAccessory}/>
				</Nav>
			</Col>
			<Col sm={12} md={6} className="Mittelspalte">
				<Switch>
					<Route path="/overview/master" component={VerbundsteuerungContainer} />
					<Route path="/overview/compressor" component={KompressorsteuerungContainer} />
					<Route path="/overview/accessories" component={ZubehoerContainer}
						disabled={!props.hasAnyAccessory}/>
					<Redirect exact from="/overview" to="/overview/master" />
				</Switch>
			</Col>
			<Col sm={12} md={3}>
				<Switch>
					<Route path="/overview/master" component={VerbundInfoPanelContainer} />
					<Route path="/overview/accessories" component={ZubehoerInfoPanelContainer}
						disabled={!props.hasAnyAccessory}/>
					<Route path="/overview/compressor/:compressorIndex" component={KompressorInfoPanelContainer} />
				</Switch>
			</Col>
		</Row>
	</Grid>
);


Uebersicht.propTypes = {
	hasAnyAccessory: PropTypes.bool.isRequired
};

export default Uebersicht;
